import { Component, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  h: Observable<string>;
  m: Observable<string>;
  s: Observable<string>;

  private start = Date.now();

  constructor() { }

  ngOnInit(): void {
    const timeSeconds = timer(0, 1000).pipe(
      map(() => Math.round((Date.now() - this.start) / 1000))
    );

    this.s = timeSeconds.pipe(
      map((s) => (s % 60).toString().padStart(2, '0'))
    );

    this.m = timeSeconds.pipe(
      map((s) => Math.floor(s / 60).toString().padStart(2, '0'))
    );

    this.h = timeSeconds.pipe(
      map((s) => Math.floor(s / 3600).toString().padStart(2, '0'))
    );
  }

}
